import { gql } from "@apollo/client";

export const ITEM_REPORT = gql`
  query reports_product_mix_ticketing_query(
    $where: reports_product_mix_ticketing_bool_exp
  ) {
    reports_product_mix_ticketing(where: $where, order_by: { pos_name: asc }) {
      unique_id
      # transaction_hour
      transaction_date
      total_units_sold
      token_units_sold
      total_net_sales
      total_tax
      total_gross_sales
      total_discounts
      total_refunds
      rfid_units_sold
      redeemable_token_id
      token_price
      product_type
      organization_name
      pos_name
      organization_id
      # order_id
      location_name
      location_id
      item_price
      event_name
      event_id
      vendor_id
      cash_balance_units_sold
      cash_units_sold
      credit_units_sold
      description
      gross_cash_sales
      gross_cash_balance_sales
      gross_credit_sales
      gross_rfid_sales
      gross_promo_balance_sales
      gross_token_sales
      total_promo_discounts
    }
  }
`;
